import React, { useEffect, useRef, useState } from 'react'
import { Logo } from '../../components/Logo'
import { UserInfo } from './UserInfo'
import { HeaderNav } from './HeaderNav'
import { LogoutButton } from './LogoutButton'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeSwitcher } from './ThemeSwitcher'
import OutsideClickHandler from 'react-outside-click-handler'
import { updateThemeColors } from '../../redux/settingSlice'

const ThemeEditor = ({theme, setTheme, close}) => {

    return (
        <OutsideClickHandler onOutsideClick={close}>
            <div className='theme-editor'>
                <input type="color" value={theme.first} onChange={(e) => setTheme(prev =>({...prev, first: e.target.value}))} />
                <input type="color" value={theme.second} onChange={(e) => setTheme(prev =>({...prev, second: e.target.value}))} />
            </div>
        </OutsideClickHandler>
    )
  }

export const Header = () => {
    const authData = useSelector((state) => state.auth);
    const [isEditTheme, setEditTheme] = useState(false);
    const dispatch = useDispatch();
    const themeColors = useSelector(state => state.settings.themeColors);
    const [theme, setTheme] = useState(themeColors);
    const isChanged = theme.first !== themeColors.first || theme.second !== themeColors.second;

    const styleRef = useRef(null);
    useEffect(() => {
        const styleElement = document.createElement('style');
        document.head.appendChild(styleElement);
        styleRef.current = styleElement;
        return () => {
          document.head.removeChild(styleElement);
        };
      }, []);

    const saveChanges = () => {
        if (isChanged) {
            dispatch(updateThemeColors(theme))
        }
        setEditTheme(false);
    }

    useEffect(() => {
        if (styleRef.current) {
            styleRef.current.innerHTML = `
            .dark-theme-bg0 {
                background: ${theme.first};
            }
            .button.active {
                background: ${theme.second};
            }
            .dark-theme-bg1 {
                background: ${theme.second};
            }
            .dark-theme-bg0-hover-bg1 {
                background: ${theme.first};
            }
            .dark-theme-bg0-hover-bg1:hover {
                background: ${theme.second};
            }
            .dark-theme-hover-bg0:hover {
                background: ${theme.first};
            }

            .dark-theme-bg1-hover-bg0 {
                background: ${theme.second};
            }
            .dark-theme-bg1-hover-bg0:hover {
                background: ${theme.first};
            }
            .dark-theme-hover-bg1:hover {
                background: ${theme.second};
            }
            `;
        }
    }, [theme]);

  return (
    <div className='header dark-theme-bg0'>
        <div className="container">
            <div className='header__logo' onClick={() => setEditTheme(true)}>
                <Logo height={32}/>
                {isEditTheme && <ThemeEditor theme={theme} setTheme={setTheme} close={saveChanges} />}
            </div>
            <div className="header__body">
                <HeaderNav user={authData} />
                <div className="header__userInfo">
                    <UserInfo fullname={authData.fullname} roleName={authData.role.name} />
                </div>
                <div className="header__logout">
                    <LogoutButton />
                </div>
                <ThemeSwitcher height={40}/>
            </div>
        </div>
    </div>
  )
}
